export default __webpack_public_path__ + "static/media/black-arrow.27a17376.svg";